module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71b4643a023fda17a8d251985914a201.png";